import React, { useEffect, useRef } from "react";
import {connect, useDispatch, useSelector} from "react-redux";
import { Tabs } from "antd";

import { i18, trb } from "@utilities";
import {
  AvailableAppActions,
  DocumentsTab,
  DowJonesTab,
  PPPTab,
  RisksTab,
  TitleCard,
  UploadTab
} from "./Components";
import { ApplicationsActions, selectCurrentApplication, selectIsSendApplication } from "@redux";
import { ContentLoader } from "@components";
import { APP_STATES } from "@config";

import "./KycApplication.less";
import {withRouter} from "react-router-dom";

const TAB_KEYS = {
  DOCUMENTS: "Documents",
  UPLOAD_DOCS: "UploadDocuments",
  DOW_JONES: "DowJones",
  RISKS: "Risk",
  PPP: "PPP"
};

const DEFAULT_TABS = [
  {
    key: TAB_KEYS.DOCUMENTS,
    name: i18.ApplicationsLabels.Documents,
    component: <DocumentsTab />
  },
  {
    key: TAB_KEYS.UPLOAD_DOCS,
    name: i18.Buttons.Upload,
    component: <UploadTab />
  }
];

const { TabPane } = Tabs;

const isPPPTabVisibleByState = [
  APP_STATES.WAITING_FOR_OFFICER_REVIEW,
  APP_STATES.WAITING_FOR_OFFICER_DOC_REVIEW
];

const isDowJonesTabVisibleByState = [
  APP_STATES.WAITING_SANCTION_LIST_APPROVAL,
  APP_STATES.WAITING_FOR_OFFICER_APPROVAL,
  APP_STATES.CHECKING_BENEFICIARY_VERIFICATION_COMPLETE,
  APP_STATES.ONBOARDING_COMPLETE,
  APP_STATES.WAITING_PRODUCT_AGREEMENT_SIGNATURE,
  APP_STATES.AGREEMENT_SIGNING_STARTED,
  APP_STATES.RENEW_COMPLETE
];

const isRisksTabVisibleByState = [
  APP_STATES.WAITING_FOR_OFFICER_APPROVAL,
  APP_STATES.CHECKING_BENEFICIARY_VERIFICATION_COMPLETE,
  APP_STATES.ONBOARDING_COMPLETE,
  APP_STATES.WAITING_PRODUCT_AGREEMENT_SIGNATURE,
  APP_STATES.AGREEMENT_SIGNING_STARTED,
  APP_STATES.RENEW_COMPLETE
];

const getIsTabVisibleByName = (tabName, currentState) => {
  if (tabName === TAB_KEYS.PPP && isPPPTabVisibleByState.includes(currentState)) {
    return (
      <TabPane tab={trb(i18.ApplicationsLabels.CheckDocument)} key={TAB_KEYS.PPP}>
        <PPPTab />
      </TabPane>
    );
  }

  if (tabName === TAB_KEYS.DOW_JONES && isDowJonesTabVisibleByState.includes(currentState)) {
    return (
      <TabPane tab={trb(i18.ApplicationsLabels.CheckSanctions)} key={TAB_KEYS.DOW_JONES}>
        <DowJonesTab />
      </TabPane>
    );
  }

  if (tabName === TAB_KEYS.RISKS && isRisksTabVisibleByState.includes(currentState)) {
    return (
      <TabPane tab={trb(i18.ApplicationsLabels.RisksScore)} key={TAB_KEYS.RISKS}>
        <RisksTab />
      </TabPane>
    );
  }

  return null;
};

const KycApplication = ({ match }) => {
  const dispatch = useDispatch();
  const application = useSelector(selectCurrentApplication);
  const isLoading = useSelector(selectIsSendApplication);
  const mountedOnce = useRef(false);

  useEffect(() => {
    if (mountedOnce.current) return;
    const appId = match.params.applicationId;
    // dont fetch the same company twice in a row
    if (appId === application?.id) return;
    (async () => {
      await dispatch(ApplicationsActions.getApplication(appId));
      mountedOnce.current = true;
    })();
  }, []);

  if (isLoading) {
    return <ContentLoader />;
  }

  return (
    <div id="card">
      <div className="w-100 page-private-container kyc-application-container">
        <TitleCard />
        <AvailableAppActions />
        <div className="tab-controller-container">
          <Tabs defaultActiveKey={TAB_KEYS.DOCUMENTS} size="default">
            {DEFAULT_TABS.map(({ name, key, component }) => (
              <TabPane tab={trb(name)} key={key}>
                {component}
              </TabPane>
            ))}
            {getIsTabVisibleByName(TAB_KEYS.PPP, application?.state)}
            {getIsTabVisibleByName(TAB_KEYS.RISKS, application?.state)}
            {getIsTabVisibleByName(TAB_KEYS.DOW_JONES, application?.state)}
          </Tabs>
        </div>
      </div>
    </div>
  );
};
const connectedKycApplication = withRouter(KycApplication)
export {connectedKycApplication as KycApplication};
